






















import Vue from 'vue'
import { MetaInfo } from 'vue-meta/types/vue-meta'
import figurePaintingModule from '@/store/figurePainting'

const moduleName = 'figurePainting' as const

export default Vue.extend({
  name: 'FigurePainting',
  metaInfo (): MetaInfo {
    return {
      title: '製作似顏繪',
      titleTemplate: '%s | nuPhoto 拍立洗'
    }
  },
  computed: {
    uploading (): boolean {
      return this.$store.state[moduleName].uploading
    },
    createing (): boolean {
      return this.$store.state[moduleName].createing
    }
  },
  async created () {
    const store = this.$store
    const { query } = this.$route
    if (!store.hasModule(moduleName)) {
      store.registerModule(moduleName, figurePaintingModule)
    }
    await store.dispatch('figurePainting/checkBrowser')
    // initital step
    this.$router
      .replace({ path: '/product120/form', query })
      .catch(() => ({}))

    window.navigateBack = () => this.$router.go(-1)
  },
  destroyed () {
    const store = this.$store
    store.unregisterModule(moduleName)
  }
})
